export default "__VITE_ASSET__K3TsScb3__"